import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {Text} from 'react-native';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';
import {useracc, postApi, putApi, deleteApi} from '../../../utils/functions';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import BBCode from '../bbcode/bbcode';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';

import './admin.css';
import { ButtonGroup } from 'react-bootstrap';


class AdminOverlay extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      key: 'api',
			info: {
				rtmp: 0,
				chat: 0
			},
			api: '',
			video: {
				mobile: {
					clubbers: [],
					radio: [],
					test: []
				},
				website: {
					clubbers: [],
					radio: [],
					test: []
				},
				clubbers: [],
				radio: [],
				technical: []
			},
			cdnNetwork: false,
			rtmp: [],
			chat: [],
			chats: [],
			djs: [],
			disbaled: false,
    };
    this.setKey = this.setKey.bind(this);
		this.djkixk = this.djkick.bind(this);
		this.djallow = this.djallow.bind(this);
		this.close = this.close.bind(this);
		this.restartService = this.restartService.bind(this);
		this.cdnNetwork = this.cdnNetwork.bind(this);
  }

  async componentDidMount() {
		await this.getData();

		this.timeout = setInterval(() => {
			this.getData();
		}, 10000);

  }

  componentWillUnmount() {
		clearTimeout(this.timeout);
  }

	setKey(key) {
		this.setState({key},()=>{
			this.getData();
		});
	}

	async djkick(id) {
		if( window.confirm("Are you sure you wish to kick this streamer?") ) {
			var params = new URLSearchParams();
			params.append("uid", id);
			const x = await putApi('/api/v2/livechat/djkick', params);
			this.setState({users: x.data.Users});
		}
	}

	async djallow(id) {
		if( window.confirm("Are you sure you wish to allow this streamer?") ) {
			var params = new URLSearchParams();
			params.append("uid", id);
			const x = await putApi('/api/v2/livechat/djallow', params);
			this.setState({users: x.data.Users});
		}
	}

	async getData() {
		let params = new URLSearchParams();
		params.append("key", this.state.key);
		const x = await postApi('/api/v2/admin/overlay', params);
		//console.log(x.data);
		let cdn = false;
		if( x.data?.cdn ) cdn = x.data.cdn;
		if( x.status === 200 ) {
			this.setState({info: x.data.info, api: x.data.api?x.data.api:'', video: x.data.video?x.data.video:{
				mobile: {
					clubbers: [],
					radio: [],
					test: []
				},
				website: {
					clubbers: [],
					radio: [],
					test: []
				},
				clubbers: [],
				radio: [],
				technical: []
			}, rtmp: x.data.rtmp?x.data.rtmp:[], chat: x.data.chat?x.data.chat:[], djs: x.data.Djs?x.data.Djs:[], cdnNetwork: cdn});
		}
	}

	timeLeft(time) {
		let left = time - Math.floor(Date.now()/1000);
		if( left < 0 ) left = 0;
		
		let _return = '';
		if( left >= 60 ) _return = Math.floor(left).toString() + " seconds";
		if( left >= 3600 ) _return = Math.floor(left/3600).toString() + " hour" + (Math.floor(left/3600)>1?"s":"");
		if( left >= 86400 ) _return = Math.floor(left/86400).toString() + " day" + (Math.floor(left/86400)>1?"s":"");
		return (
			<>
				{_return} remaining
			</>
		)
	}

	timeAgo(time) {
		const _time = Math.floor( ((Date.now()/1000) - time) / 60) ;
		var _return = '';
		if( _time >= 10 ) _return = Math.floor(_time).toString() + " mins";
		if( _time >= 60 ) _return = Math.floor(_time/60).toString() + " hour" + (Math.floor(_time/60)>1?"s":"");
		if( _time >= 1440 ) _return = Math.floor(_time/1440).toString() + " day" + (Math.floor(_time/1440)>1?"s":"");
		return( <small>&nbsp;&nbsp;{_return}</small> );
	}

	rankColor(rank) {
		switch( rank ) {
			case "Owner": return '#DC143C';
			case "Admin": return '#FF4500';
			case "DJ": return '#273be2';
			default: return '#228B22';
		}
		//if( rank === "Owner" ) return '#FFD700';
		//return '#ffff00';
	}

	async getChats(ctime, channel) {
		// ??? channel

		let params = new URLSearchParams();
		params.append("ctime", ctime);
		params.append("channel", channel);
		const x = await postApi('/api/v2/admin/getchats', params);
		if( x.status === 200 ) {
			this.setState({chats: x.data.chats?x.data.chats:[]});
		}
	}

	async removeKick(id) {
		if( window.confirm("Are you sure you wish to remove this ban?") ) {

			let params = new URLSearchParams();
			params.append("id", id);
			const x = await deleteApi('/api/v2/admin/removeBan', params);

		}
	}

	closeChats() {
		this.setState({chats: []});
	}

	close() {
		//console.log("here");
		this.props.close();
	}

	async restartService(service) {
		if( window.confirm("Are you sure you width to restart this service?") ) {
			this.setState({disbaled: true}, async ()=>{
				let params = new URLSearchParams();
				params.append('service', service);
				await putApi('/api/v2/admin/restart', params);
				this.setState({disabled: false});
			});
		}
	}

	async cdnNetwork(event) {
		this.setState({cdnNetwork: event.target.checked},async ()=>{
			let params = new URLSearchParams();
			params.append('cdn', event.target.checked===true?1:0);
			await putApi('/api/v2/admin/cdnnetwork', params);
		});

		
	}

  render() {
		const user = this.context;
		const clubbersMobile = this.state.video.mobile.clubbers.map((e,i) => {
			return (
				<React.Fragment key={i}>{this.state.video.mobile.clubbers[i].address.replace('::ffff:','')} - {this.state.video.mobile.clubbers[i].city}, {this.state.video.mobile.clubbers[i].country}<br /></React.Fragment>
			)
		})
		const clubbersWebsite = this.state.video.website.clubbers.map((e,i) => {
			return (
				<React.Fragment key={i}>{this.state.video.website.clubbers[i].address.replace('::ffff:','')} - {this.state.video.website.clubbers[i].city}, {this.state.video.website.clubbers[i].country}<br /></React.Fragment>
			)
		})

		const radioMobile = this.state.video.mobile.radio.map((e,i) => {
			return (
				<React.Fragment key={i}>{this.state.video.mobile.radio[i].address.replace('::ffff:','')} - {this.state.video.mobile.radio[i].city}, {this.state.video.mobile.radio[i].country}<br /></React.Fragment>
			)
		})
		const radioWebsite = this.state.video.website.radio.map((e,i) => {
			return (
				<React.Fragment key={i}>{this.state.video.website.radio[i].address.replace('::ffff:','')} - {this.state.video.website.radio[i].city}, {this.state.video.website.radio[i].country}<br /></React.Fragment>
			)
		})

		const testMobile = this.state.video.mobile.test.map((e,i) => {
			return (
				<React.Fragment key={i}>{this.state.video.mobile.test[i].address.replace('::ffff:','')} - {this.state.video.mobile.test[i].city}, {this.state.video.mobile.test[i].country}<br /></React.Fragment>
			)
		})
		const testWebsite = this.state.video.website.test.map((e,i) => {
			return (
				<React.Fragment key={i}>{this.state.video.website.test[i].address.replace('::ffff:','')} - {this.state.video.website.test[i].city}, {this.state.video.website.test[i].country}<br /></React.Fragment>
			)
		})

		const video = Object.keys(this.state.video).map((e,i) => {
			return (
				<Row key={i}>
					{this.state.video[e] instanceof Array && this.state.video[e].length > 0 &&
						<>
							<Col xs={12}>
								<h4>{e.charAt(0).toUpperCase()}{e.slice(1)} Viewers</h4>
							</Col>
							<Col xs={12}>

							<table className="table text-nowrap">
								<tbody>
							
									{this.state.video[e].map((f,j) => {
										return (
											<tr key={j}>
												<td style={{border: 0}}>{f.username}</td>
												<td style={{border: 0}}>{f.address}</td>
												<td style={{border: 0}}>{f.server.replace('ultrastream.io','mix365.co.uk')}</td>
												<td style={{border: 0}}>{f.location}</td>
											</tr>
										)
									})}
								
							
								</tbody>
							</table>
						</Col>
					</>
					}
				</Row>
			)
		})
		const djs = Object.keys(this.state.djs).map((e,i) => {
			return (
				<Row key={i}>
					<div className="" style={{width: 100}}>
						<div className="admin-avatar mx-3 mt-2">
							<img src={`https://mix365.co.uk${this.state.djs[e].avatar}`} alt="profile avatar" />
						</div>
					</div>
					<Col className="ps-4 pt-3">
						<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
							Mix365 {this.state.djs[e].channel}<br />
							<Button size="sm" onClick={()=>this.djkick(this.state.djs[e].uid)}>Kick {this.state.djs[e].username}</Button>
						</div>
					</Col>
				</Row>
			)
		})
		const rtmp = Object.keys(this.state.rtmp).map((e,i) => {
			return (
				<Row key={i}>
					<div className="" style={{width: 100}}>
						<div className="admin-avatar mx-3 mt-2">
							<img src={`https://mix365.co.uk${this.state.rtmp[e].avatar}`} alt="profile avatar" />
						</div>
					</div>
					<Col className="ps-4 pt-3">
						<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
							<Button size="sm" onClick={()=>this.djallow(this.state.rtmp[e].id)}>Allow {this.state.rtmp[e].username}</Button>
						</div>
					</Col>
				</Row>
			)
		})
		const chat = Object.keys(this.state.chat).map((e,i) => {
			return (
				<Row key={i}>
					<div className="" style={{width: 100}}>
						<div className="admin-avatar mx-3 mt-2">
							<img src={`https://mix365.co.uk${this.state.chat[e].ban_avatar}`} alt="profile avatar" />
						</div>
					</div>
					<Col className="ps-4 pt-3">
						
						<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
							{this.state.chat[e].ban}<br />
							{this.timeLeft(this.state.chat[e].ban_time)}
							{/*<Button size="sm" onClick={()=>this.djallow(this.state.chat[e].id)}>Allow {this.state.chat[e].username}</Button>*/}
						</div>
						
					</Col>
					<div className="" style={{width: 100}}>
						<div className="admin-avatar mx-3 mt-2">
							<img src={`https://mix365.co.uk${this.state.chat[e].user_avatar}`} alt="profile avatar" />
						</div>
					</div>
					<Col className="ps-4 pt-3">
						
						<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
							kicked by {this.state.chat[e].user} on {this.state.chat[e].channel}<br />
							
							<ButtonGroup size="sm">
								<Button onClick={()=>this.getChats(this.state.chat[e].ctime, this.state.chat[e].channel)}>View Chats</Button>
								<Button onClick={()=>this.removeKick(this.state.chat[e].id)}>Remove Ban</Button>
							</ButtonGroup>
						</div>
						
					</Col>
				</Row>
			)
		})
		const chats = Object.keys(this.state.chats).map((e,i) => {
			return (
				<div key={e}>
					
						<div className="col-12 py-0 chatbox-message">
							<div className="row pb-2">
								<div className="text-center pt-2 px-2 mx-0 chatbox-avatar">
									<img src={`https://mix365.co.uk${this.state.chats[e].avatar}`} alt="A" style={{width: 30, height: 30, borderRadius: '50%'}} />
									{//user.user.user.rank>=5&&
										<div className="chatbox-level" style={{backgroundColor: this.rankColor(this.state.chats[e].level)}}></div>
									}
								</div>
								<div className="col ps-0 pe-5 pt-0 mx-0 chatbox-element">
									<Link to={`/${this.state.chats[e].username.toLowerCase().replaceAll(' ','_')}`} style={{color: 'rgb(55, 186, 251)'}}>{this.state.chats[e].djtitle?this.state.chats[e].djtitle:this.state.chats[e].username}</Link>
									{this.timeAgo(this.state.chats[e].time)}<br />
									{this.state.chats[e].reply > 0 &&
										<React.Fragment>
											
											<FontAwesomeIcon icon="reply" size="xs" /> {this.state.chats[e]._reply.djtitle?this.state.chats[e]._reply.djtitle:this.state.chats[e]._reply.username}<br />
											<div className="chatbox-message-reply-message">
												<BBCode text={this.state.chats[e]._reply.text.length>75?this.state.chats[e]._reply.text.substring(0,100)+'...':this.state.chats[e]._reply.text} /><br />
											</div>
										</React.Fragment>
									}
									{this.state.chats[e].flags===1?
										<div className="mssage-delete">Message Deleted<br />
											<BBCode text={this.state.chats[e].text} />
										</div>
									:
										<BBCode text={this.state.chats[e].text} />
									}
									
								</div>
							</div>
						</div>
					
				</div>
			)
		})
    return (
      <div className="admin-overlay">
				<Tabs defaultActiveKey="api" id="uncontrolled-tab-example" className="mb-3" onSelect={(k) => this.setKey(k)} style={{position: 'relative'}}>
					<Tab eventKey="api" title="API" style={{position: 'relative', height: '100%', overflowX: 'hidden', overflowY: 'scroll'}}>
						<div >
							<Text style={{color: '#ffffff'}}>{this.state.api}</Text>
						</div>
					</Tab>
					<Tab eventKey="video" title="VIDEO" style={{position: 'relative', height: '100%', overflowX: 'hidden', overflowY: 'scroll'}}>
						<Row>
							<Col xs={12}>
								<h4>CDN Network</h4>
							</Col>
							<Col>
								<div style={{float: 'left', paddingBottom: 20}}>
									<Form.Check // prettier-ignore
										type="switch"
										id="cdn_network"
										size="sm"
										onChange={this.cdnNetwork}
										checked={this.state.cdnNetwork}
										//disabled={user.user.user?.id === 3?false:true}
									/>
								</div>
								<div style={{float: 'left'}}>
									CDN Network Status: {this.state.cdnNetwork===true?'ON':'OFF'}
								</div>
							</Col>
						</Row>
						{/*(Object.keys(this.state.video.mobile.clubbers).length > 0 || Object.keys(this.state.video.website.clubbers).length > 0) &&
							<>
								<h3>Clubbers</h3>
								Mobile Viewers: <br />
								{clubbersMobile}
								Website Viewers: <br />
								{clubbersWebsite}<br />
							</>
						}
						{(Object.keys(this.state.video.mobile.radio).length > 0 || Object.keys(this.state.video.website.radio).length > 0) &&
							<>
								<h3>Radio</h3>
								Mobile Viewers: <br />
								{radioMobile}
								Website Viewers: <br />
								{radioWebsite}<br />
							</>
						}
						{(Object.keys(this.state.video.mobile.test).length > 0 || Object.keys(this.state.video.website.test).length > 0) &&
							<>
								<h3>Test</h3>
								Mobile Viewers: <br />
								{testMobile}
								Website Viewers: <br />
								{testWebsite}
							</>
						*/}
						{video}
					</Tab>
					<Tab eventKey="rtmp_kicked" title={`RTMP KICKED ${this.state.info.rtmp?this.state.info.rtmp:''}`} style={{position: 'relative', height: '100%', overflowX: 'hidden', overflowY: 'scroll'}}>
						Streaming DJ's:
						{Object.keys(this.props.live).length > 0 &&
							<>
							{/*<Row>
								
								<div style={{width: 100}}>
									<div className="admin-avatar mx-3 mt-2">
										<img src={`https://mix365.co.uk${this.props.live.avatar}`} alt="profile avatar" />
									</div>
								</div>
								<Col className="ps-4 pt-3">
									
									<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
										<Button size="sm" onClick={()=>this.djkick(this.props.live.uid)}>Kick {this.props.live.username}</Button>
									</div>
									
								</Col>
								
							</Row>*/}
							<Row>
								{djs}
							</Row>
							</>
						}
						
						
						<br /><br />
						Kicked DJ's:<br/>
						{rtmp}
					</Tab>
					<Tab eventKey="chat_kicked" title={`CHAT KICKED ${this.state.info.chat?this.state.info.chat:''}`} style={{position: 'relative', height: '100%', overflowX: 'hidden', overflowY: 'scroll'}}>
						{Object.keys(this.state.chats).length > 0 ?
							<>
								<div className="admin-chats-close text-right" onClick={()=>this.closeChats()}>
									<FontAwesomeIcon icon="times" />&nbsp;&nbsp;&nbsp;
								</div>
								{chats}
							</>
						:
							<>
								Members kicked for 24 hours<br />
								{chat}
							</>
						}
					</Tab>
					<Tab eventKey="restart" title="RESTART" style={{position: 'relative', height: '100%', overflowX: 'hidden', overflowY: 'scroll'}}>
						<Row>
							<Col xs={12}>
								<h4>Website Mix365 API</h4>
								<Button size="sm" onClick={()=>this.restartService("restart-api")} disabled={this.state.disabled}>Restart API</Button><br />
								<p>
									Please restart the API when there are issues with the website and including handovers between DJs<br />
									* Restarting this service will not affect current live DJ's
								</p>
							</Col>
							<Col xs={12}>
								<h4 className="pt-3">Node Media Server - Video Platform</h4>
								<Button size="sm" onClick={()=>this.restartService("restart-nms")} disabled={this.state.disabled}>Restart NMS</Button><br />
								<p>
									<strong>Restarting this service will KILL all live streams</strong><br />
									Before restarting the Node-Media-Server, please ensure and check the following before restarting:<br />
									* This is primarily for incoming video streams, DJ connecting to the server.<br />
									* DJ has the correct stream key,<br />
									* DJ account is NOT banned,<br />
									* DJ has the correct rank (DJ or Above),<br />
									
								</p>
							</Col>
							<Col xs={12}>
								<h4 className="pt-3">Video Content Delivery Network</h4>
								<Button size="sm" onClick={()=>this.restartService("restart-cdn")} disabled={this.state.disabled}>Restart CDN</Button><br />
								<p>
									Please restart the CDN when there are issues with video streams not starting<br />
									* This is primarily for outgoing video streams, video stream out to the audience<br />
									* Restarting this service will not affect current live DJ's
								</p>
							</Col>
						</Row>
					</Tab>
					<Tab eventKey="close" title={`CLOSE`} style={{position: 'relative', height: '100%', overflowX: 'hidden', overflowY: 'scroll'}}>
						<Button size="sm" onClick={this.close}>Close Panel</Button>
					</Tab>
				</Tabs>
			</div>
    )
  }
}

export default AdminOverlay;
